import { Client } from '../components/admin/clients/store/types';
import { api } from './services';

export type DeleteClientRequest = { clientId: number; };
type UploadDocumentsRequest = FormData;

export const fetchAllClients = async () => await api('client/getAll', {}, 'get');
export const updateClient = async (reqBody: Client) => await api('client/update', { ...reqBody }, 'post');
export const createClient = async (reqBody: Client) => await api('client/create', { ...reqBody }, 'post');
export const deleteClient = async (reqBody: DeleteClientRequest) => await api('client/delete', { ...reqBody }, 'post');
export const fetchAvailableClientFeaturePermissions = async () => await api('client/permissions/getAll', {}, 'get');
export const uploadTermsAndConditionsDocuments = async (reqBody: UploadDocumentsRequest) => await api('client/termsAndConditions/upload', reqBody, 'post', {}, true);
export const downloadTermsAndConditionsDocument = async (reqBody: { clientTermsDocumentId: number; clientId: number; }) => await api('client/termsAndConditions/download', { ...reqBody }, 'post', {}, false, true);
export const downloadAllClientData = async (reqBody: { socketId: string; clientId: number; }) => await api('client/data/download', { ...reqBody }, 'post');
